import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StrongAuthenticationComponent } from './strong-authentication.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SuccessMessageComponent } from 'src/app/components/success-message/success-message.component';



@NgModule({
  declarations: [
    StrongAuthenticationComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ComponentsModule
  ],
  providers: [
    SuccessMessageComponent
  ]
})
export class StrongAuthenticationModule { }
